export const ShutdownMethodName = "T42.ACS.Shutdown";
export const OnGDShutdownMethodName = "T42.ACS.OnGDShutdown";
export const RestartMethodName = "T42.ACS.Restart";

export const FeedbackMethodName = "T42.ACS.Feedback";

export const GetConfigurationRegionMethodName = "T42.ACS.GetConfigurationRegion";
export const SetConfigurationRegionMethodName = "T42.ACS.SetConfigurationRegion";

export const GetUserMethodName = "T42.ACS.GetUser";
export const GetBranchesMethodName = "T42.ACS.GetBranches";
export const GetCurrentBranchMethodName = "T42.ACS.GetCurrentBranch";
export const SetCurrentBranchMethodName = "T42.ACS.SetCurrentBranch";

export const GetFunctionalEntitlementMethodName = "T42.ACS.GetFunctionalEntitlement";
export const CanIMethodName = "T42.ACS.CanI";

export const StartApplicationMethodName = "T42.ACS.StartApplication";
export const StopApplicationMethodName = "T42.ACS.StopApplication";
export const ActivateApplicationMethodName = "T42.ACS.ActivateApplication";
export const RunApplicationMethodName = "T42.ACS.RunApplication";

export const OnEventMethodName = "T42.ACS.OnEvent";

export const GetApplicationsMethodName = "T42.ACS.GetApplications";
